export enum ProcurementKnowledgeDataGridColumn {
  FILE_ID = 'fileId',
  TITLE = 'title',
  DESCRIPTION = 'description',
  FILE_NAME = 'fileName',
  TYPE = 'mimeType',
  VARIANT = 'variant',
  LANGUAGE = 'language',
  UPDATED_AT = 'updatedAt',
  URL = 'url',
  ACTIONS = 'actions',
}
